import { useEffect, useState } from "react";
import { SelectInput, useDataProvider } from "react-admin";

const CoachInput = ({ label, fullWidth = false }) => {
  const [coachUsers, setCoachUsers] = useState([]);
  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider
      .getList("users", {})
      .then(({ data }) => {
        const coachUsers = data.filter((el) => el.access_level === "coach");

        const array = [];

        for (const coach of coachUsers) {
          array.push({ id: coach.id, name: coach.name });
        }

        setCoachUsers(array);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <SelectInput
      fullWidth={fullWidth}
      label={label ? label : "Лідер"}
      source="coach_id"
      choices={coachUsers}
    />
  );
};

export default CoachInput;
